import './styles.scss';
import { DisposalSet, onReadyEach, select, selectAll } from '../../utils';
import { addToMultiParamMap, removeFromMultiParamMap, replaceInMultiParamMap, toMultiParamMap, toURLSearchParams, updateResults } from '../../fragments/layouts/aoc-search-layout/facets';
const gc = new DisposalSet();
const initCategoryTreeFacet = (facetEl, pageParam, isMutex) => {
  const parentFormEl = facetEl.parentElement;
  const searchLayoutEl = facetEl.closest('.aoc-search-layout');
  if (!parentFormEl || !searchLayoutEl) return;
  const facetParamName = select(parentFormEl, 'input.facet-parameter-name');
  const treeItemCheckboxEls = selectAll(facetEl, '.aoc-category-tree-facet__item input[type="checkbox"]');
  for (const checkboxEl of treeItemCheckboxEls) {
    gc.register(checkboxEl).addListener('change', e => {
      const multiParamMap = toMultiParamMap(new URLSearchParams(window.location.search));
      const value = checkboxEl.value;
      if (checkboxEl.checked) {
        if (isMutex) {
          replaceInMultiParamMap(multiParamMap, facetParamName.value, value);
          for (const otherCheckboxEl of treeItemCheckboxEls) {
            if (otherCheckboxEl !== checkboxEl) {
              otherCheckboxEl.checked = false;
            }
          }
        } else {
          addToMultiParamMap(multiParamMap, facetParamName.value, value);
        }
      } else {
        removeFromMultiParamMap(multiParamMap, facetParamName.value, value);
      }
      removeFromMultiParamMap(multiParamMap, 'start', null);
      const params = toURLSearchParams(multiParamMap);
      const nextUrl = `${window.location.pathname}?${params}`;
      updateResults(searchLayoutEl, nextUrl, pageParam);
    });
  }
};
export const reinit = (parentEl, replacements, pageParam) => {
  gc.disposeAll();
  const facetEls = selectAll(parentEl, '.aoc-category-tree-facet');
  for (let i = 0; i < facetEls.length; i++) {
    const facetEl = facetEls[i];
    const isMutex = facetEl.dataset.isMutex === 'true';
    const replacementFacetEl = replacements[i];
    const existingListEls = selectAll(facetEl, '.aoc-category-tree-facet__list--depth-1');
    const replacementListEls = selectAll(replacementFacetEl, '.aoc-category-tree-facet__list--depth-1');
    for (let k = 0; k < existingListEls.length; k++) {
      const existingListEl = existingListEls[k];
      const replacementListEl = replacementListEls[k];
      if (existingListEl && replacementListEl) {
        existingListEl.parentElement.replaceChild(replacementListEl, existingListEl);
      }
    }
    initCategoryTreeFacet(facetEl, pageParam, isMutex);
  }
};
onReadyEach('.aoc-category-tree-facet', facetEl => {
  initCategoryTreeFacet(facetEl, 'start', facetEl.dataset.isMutex === 'true');
});
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.dispose(() => gc.disposeAll());
}